/*
  Kalessie - shared add-to-cart. Global delegated handler for any
  [data-kal-atc] button (product cards, cross-sell, related). Adds the variant
  via Dawn's cart routes and reuses Dawn's cart drawer/notification so the whole
  native cart UI updates; flashes the button green on success. Also exposes
  window.KalCart.add(id, btn) for Quick View to reuse.
*/
(function () {
  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  // cart_type = "page": no drawer/notification element is on the page, so update the
  // header cart-count bubble directly from the rendered 'cart-icon-bubble' section
  // (same markup + '.shopify-section' selector Dawn uses) so the count stays live.
  function updateCartIconBubble(res) {
    if (!res || !res.sections || !res.sections['cart-icon-bubble']) return;
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
    var section = doc.querySelector('.shopify-section');
    el.innerHTML = section ? section.innerHTML : doc.body.innerHTML;
  }

  // On the cart page itself there is no drawer or notification to re-render,
  // so the line items and order summary have to be refreshed directly —
  // otherwise adding a cross-sell only moved the header count and the shopper
  // had to reload to see what they had just added. Mirrors how Dawn's own
  // cart.js re-renders: request by the section's data-id, swap in .js-contents.
  function cartPageSections() {
    return ['main-cart-items', 'main-cart-footer'].reduce(function (out, id) {
      var el = document.getElementById(id);
      if (el && el.dataset.id) out.push({ id: id, section: el.dataset.id, selector: '.js-contents' });
      return out;
    }, []);
  }

  function renderCartPage(res, sections) {
    if (!res || !res.sections) return;
    sections.forEach(function (s) {
      var html = res.sections[s.section];
      var host = document.getElementById(s.id);
      if (!html || !host) return;
      var dest = host.querySelector(s.selector);
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      if (dest && src) dest.innerHTML = src.innerHTML;
    });
  }

  function add(id, btn) {
    if (!id) return;
    var cart = getCart();
    var pageSections = cartPageSections();
    var data = { items: [{ id: Number(id), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      data.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
    } else {
      // cart_type "page" - no drawer/notification, but still refresh the header count.
      data.sections = ['cart-icon-bubble'].concat(
        pageSections.map(function (s) { return s.section; })
      );
    }
    data.sections_url = window.location.pathname;
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        if (res.status) {
          window.alert(res.description || res.message || 'Could not add to cart');
          return res;
        }
        if (cart && typeof cart.renderContents === 'function') {
          try { cart.renderContents(res); } catch (e) { /* never let a render error kill the button feedback */ }
        } else {
          try { updateCartIconBubble(res); } catch (e) { /* count refresh is best-effort */ }
          try { renderCartPage(res, pageSections); } catch (e) { /* ditto */ }
        }
        // Nudge the free-shipping bar (it refreshes from /cart.js on this event).
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
        if (btn) {
          btn.classList.add('is-added');
          btn.textContent = '✓ Added!';
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.textContent = orig;
          }, 1600);
        }
        return res;
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kal-atc]') : null;
    if (!btn) return;
    e.preventDefault();
    add(btn.getAttribute('data-variant-id'), btn);
  });

  // PDP: flash the main Add-to-cart button green when the main product is added
  // (Dawn's product-form publishes cartUpdate with source 'product-form').
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      var atc = document.querySelector('[id^="ProductSubmitButton-"]');
      if (!atc) return;
      var span = atc.querySelector('span');
      var prev = span ? span.textContent : null;
      atc.classList.add('kal-atc-added');
      if (span) span.textContent = '✓ Added to cart';
      setTimeout(function () {
        atc.classList.remove('kal-atc-added');
        if (span && prev !== null) span.textContent = prev;
      }, 1600);
    });
  }

  window.KalCart = { add: add };
})();
